import request from '@/api/request'

//PC工作台-需求列表
export function jobList(data) {
    return request({
        url: '/api/director/job/lists',
        method: 'GET',
        params: data
    })
}


//PC工作台-需求添加
export function addJob(data) {
    return request({
        url: '/api/director/job/add',
        method: 'POST',
        data
    })
}



//PC工作台-职位类型
export function getClassTree(data) {
    return request({
        url: '/api/jobClass/getClassTree',
        method: 'GET',
        params: data
    })
}



//PC工作台-需求修改
export function updateJob(data) {
    return request({
        url: '/api/director/job/update',
        method: 'POST',
        data
    })
}

export function changeStatus(data) {
    return request({
        url: '/api/director/job/changeStatus',
        method: 'POST',
        data
    })
}



export function jobDetail(data) {
    return request({
        url: '/api/director/job/info',
        method: 'GET',
        params: data
    })
}

//职位展示接口
export function jobShow(data) {
    return request({
        url: '/api/job/jobShow',
        method: 'GET',
        params: data
    })
}





